// ProfileSection.js
import React from "react";

export default function ProfileSection({ title, onEdit, children }) {
  return (
    <section className="profile-section">
      <div className="profile-section-header">
        <h3>{title}</h3>
        {onEdit && (
          <button className="common-edit-btn" onClick={onEdit}>
            Edit
          </button>
        )}
      </div>
      {children}
    </section>
  );
}
